// extracted by mini-css-extract-plugin
module.exports = {"backgroundBlue":"cXD8_","blackFridayContainer":"_1byKb","nudgeCardContainer":"_1mIpt","nudgeCardContainerNew":"_3UUju"};